import Vue from 'vue';
import ConfirmDialogue from "@/components/dialogues/ConfirmDialogue";
import ErrorDialogue from "@/components/dialogues/ErrorDialogue";
import ImageViewer from "@/components/dialogues/ImageViewer";

Vue.component('confirmDialogue', ConfirmDialogue)
Vue.component('errorDialogue', ErrorDialogue)
Vue.component('imageViewer', ImageViewer)
